<template>
  <div class="loyalty-birthday-field">
    <label :for="id">Cumpleaños <span>(opcional)</span></label>
    <input :id="id" ref="input" :value="birthdayText" type="text" inputmode="numeric" placeholder="DD/MM"
      maxlength="5" autocomplete="off" :disabled="disabled" :aria-invalid="birthdayInvalid"
      :aria-describedby="touched && birthdayInvalid ? id + '-error' : undefined" @input="changeBirthday" @blur="touched = true">
    <small v-if="touched && birthdayInvalid" :id="id + '-error'" class="birthday-error">Indica un día y un mes válidos (DD/MM), o déjalo vacío.</small>
  </div>
</template>

<script>
function formatBirthday(value) {
  return value.birthday_day && value.birthday_month ? String(value.birthday_day).padStart(2, '0') + '/' + String(value.birthday_month).padStart(2, '0') : '';
}
function parts(text) {
  const [day, month] = text.split('/');
  return { birthday_day: day ? Number(day) : null, birthday_month: month ? Number(month) : null };
}
export default {
  name: 'LoyaltyBirthdayField',
  props: { id: { type: String, required: true }, modelValue: { type: Object, required: true }, disabled: { type: Boolean, default: false } },
  emits: ['update:modelValue'],
  data() { return { birthdayText: formatBirthday(this.modelValue), touched: false }; },
  computed: {
    birthdayInvalid() {
      if (!this.birthdayText) return false;
      if (!/^\d{2}\/\d{2}$/.test(this.birthdayText)) return true;
      const { birthday_day: day, birthday_month: month } = parts(this.birthdayText);
      const value = new Date(Date.UTC(2000, month - 1, day));
      return value.getUTCDate() !== day || value.getUTCMonth() + 1 !== month;
    },
  },
  watch: {
    modelValue: { deep: true, handler(value) {
      const current = parts(this.birthdayText);
      if ((value.birthday_day ?? null) !== current.birthday_day || (value.birthday_month ?? null) !== current.birthday_month) {
        this.birthdayText = formatBirthday(value); this.touched = false; this.$nextTick(this.validate);
      }
    } },
  },
  mounted() { this.validate(); },
  methods: {
    validate() { this.$refs.input?.setCustomValidity(this.birthdayInvalid ? 'Indica un día y un mes válidos (DD/MM), o déjalo vacío.' : ''); },
    changeBirthday(event) {
      const digits = event.target.value.replace(/\D/g, '').slice(0, 4);
      this.birthdayText = digits.length > 2 ? digits.slice(0, 2) + '/' + digits.slice(2) : digits;
      event.target.value = this.birthdayText;
      this.validate();
      this.$emit('update:modelValue', { ...this.modelValue, ...parts(this.birthdayText) });
    },
  },
};
</script>

<style scoped>
.loyalty-birthday-field { margin: 0 0 16px; text-align: left; }
.loyalty-birthday-field label { display: block; margin-bottom: 7px; color: #233447; font-size: .85rem; font-weight: 700; }
.loyalty-birthday-field label span { color: #697887; font-weight: 400; }
.loyalty-birthday-field input { box-sizing: border-box; display: block; width: 100%; min-height: 48px; padding: 12px 14px; border: 1px solid #d3dce5; border-radius: 14px; background: white; color: #233447; font-size: 1rem; }
.loyalty-birthday-field input:focus { outline: 2px solid var(--loyalty-primary, var(--primary-color, #f47700)); outline-offset: 2px; }
.birthday-error { display: block; margin-top: 6px; color: #a42e24; font-size: .74rem; line-height: 1.4; }
</style>
